'use es6';

import Client from 'ads-account-connection/data/Client';
const adAccountUrl = 'ads/v1/ad-account';
export const fetchOverview = () => {
  return Client.apiRequest(`${adAccountUrl}/user-overview`);
};
export const fetchMyPermissions = () => {
  return Client.apiRequest(`${adAccountUrl}/my-permissions`);
};